var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
// dependency-injection
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { OpportunityActionsService } from '@/services/opportunity-management/opportunity-actions-service';
import { MaterialService } from '@/services/material-management/material-service';
import { VendorService } from '@/services/vendor-service';
import { CarrierService } from '@/services/carrier-management/carrier-service';
import { SiteService } from '@/services/site-management/site-service';
// components
import TableMixin from '@/mixins/table-mixin';
import OpportunityTableMixin from '@/mixins/opportunity-management/opportunity-table-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
var AddLoadPrompt = function () { return import('@/pages/opportunity-management/shared/prompts/AddLoadPrompt.vue'); };
var OpportunityTableRow = function () { return import('@/pages/opportunity-management/shared/OpportunityTableRow.vue'); };
var OpportunityItem = function () { return import('@/pages/opportunity-management/shared/OpportunityItem.vue'); };
import * as isToday from 'date-fns/is_today';
import * as isAfter from 'date-fns/is_after';
import * as format from 'date-fns/format';
import * as uuid_v4 from 'uuid/v4';
import { Validator } from 'vee-validate';
import { mask } from 'vue-the-mask';
var UpMarketOpportunities = /** @class */ (function (_super) {
    __extends(UpMarketOpportunities, _super);
    function UpMarketOpportunities() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingOpportunities = false;
        _this.opportunities = [];
        _this.options = {
            materials: [],
            timeWindows: [],
            sourceTypes: [],
            vendors: [],
            carriers: [],
        };
        // values for time window menu
        _this.timeWindowTarget = document.getElementById('opportunityTable');
        _this.timeWindowMenuOpened = false;
        _this.previousTimeWindowStart = '';
        _this.currentTimeWindowStart = '';
        _this.previousTimeWindowEnd = '';
        _this.currentTimeWindowEnd = '';
        _this.id = '';
        return _this;
    }
    UpMarketOpportunities.prototype.beforeMount = function () {
        this.serviceSymbol = TYPES.OpportunityActionsService;
    };
    UpMarketOpportunities.prototype.openTimeWindowDialog = function (props, $event) {
        // stop the event propagation
        $event.stopPropagation();
        // set the target
        this.timeWindowTarget = document.getElementById($event.target.id);
        // save the id of the item being updated
        this.id = props.item.id;
        // set previous values
        this.previousTimeWindowStart = props.item.timeWindowStart;
        this.previousTimeWindowEnd = props.item.timeWindowEnd;
        // set current values, used for data binding to drop downs
        this.currentTimeWindowStart = props.item.timeWindowStart;
        this.currentTimeWindowEnd = props.item.timeWindowEnd;
        // open the menu
        this.timeWindowMenuOpened = true;
    };
    UpMarketOpportunities.prototype.cancelTimeWindowDialog = function (props) {
        var _this = this;
        var opportunities = __spreadArrays(this.opportunities);
        this.opportunities = opportunities.map(function (item) {
            if (item.id === _this.id) {
                // reset to the original value
                item.timeWindowStart = _this.previousTimeWindowStart;
                item.timeWindowEnd = _this.previousTimeWindowEnd;
            }
            return item;
        });
        // close the menu
        this.timeWindowMenuOpened = false;
    };
    UpMarketOpportunities.prototype.saveTimeWindowDialog = function (props) {
        var _this = this;
        var matchingItem = this.opportunities.find(function (item) { return item.id === _this.id; });
        // validate end is after start
        if (+this.currentTimeWindowEnd <= +this.currentTimeWindowStart) {
            this.showSnackbar({
                text: 'Time Window End time must be after Time Window Start Time',
                color: 'error',
            });
            return;
        }
        var opportunities = __spreadArrays(this.opportunities);
        this.opportunities = opportunities.map(function (item) {
            if (item.id === _this.id) {
                // reset to the original value
                item.timeWindowStart = _this.currentTimeWindowStart;
                item.timeWindowEnd = _this.currentTimeWindowEnd;
            }
            return item;
        });
        // close the menu
        this.timeWindowMenuOpened = false;
    };
    UpMarketOpportunities.prototype.openAddLoadPrompt = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var v, valid, allErrors, errors;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        v = new Validator();
                        valid = false;
                        allErrors = [];
                        errors = [];
                        return [4 /*yield*/, v.verify(item.materialId, 'required', { name: 'Material' })];
                    case 1:
                        // Material
                        (_a = _h.sent(), valid = _a.valid, errors = _a.errors);
                        if (!valid) {
                            allErrors.push(errors);
                        }
                        return [4 /*yield*/, v.verify(item.loadSize, 'required|numeric|min:1|max:5|min_value:1|max_value:99999', { name: 'Load Size' })];
                    case 2:
                        // Load size
                        (_b = _h.sent(), valid = _b.valid, errors = _b.errors);
                        if (!valid) {
                            allErrors.push(errors);
                        }
                        return [4 /*yield*/, v.verify(item.timeWindowStart, 'required|numeric', { name: 'Time Window Start' })];
                    case 3:
                        // Time window start
                        (_c = _h.sent(), valid = _c.valid, errors = _c.errors);
                        if (!valid) {
                            allErrors.push(errors);
                        }
                        return [4 /*yield*/, v.verify(item.timeWindowEnd, 'required|numeric', { name: 'Time Window End' })];
                    case 4:
                        // Time window end
                        (_d = _h.sent(), valid = _d.valid, errors = _d.errors);
                        if (!valid) {
                            allErrors.push(errors);
                        }
                        return [4 /*yield*/, v.verify(item.sourceType, 'required', { name: 'Source Type' })];
                    case 5:
                        // Source type
                        (_e = _h.sent(), valid = _e.valid, errors = _e.errors);
                        if (!valid) {
                            allErrors.push(errors);
                        }
                        return [4 /*yield*/, v.verify(item.vendorId, 'required_if:sourceType,CONTRACT,MANUAL', { name: 'Source', values: { sourceType: item.sourceType } })];
                    case 6:
                        // Source / Vendor
                        (_f = _h.sent(), valid = _f.valid, errors = _f.errors);
                        if (!valid) {
                            allErrors.push('The Source field is required when the Source Type is CONTRACT or MANUAL.');
                        }
                        return [4 /*yield*/, v.verify(item.dispatchDeskId, 'required', { name: 'Dispatch Desk' })];
                    case 7:
                        // Dispatch Desk
                        (_g = _h.sent(), valid = _g.valid, errors = _g.errors);
                        if (!valid) {
                            allErrors.push(errors);
                        }
                        // Output the error messages
                        if (allErrors.length > 0) {
                            this.showSnackbar({
                                text: allErrors.length < 5
                                    ? allErrors.join(' | ')
                                    : 'Unable to add suggested load. Please check to ensure that material, load size, time window, source type, source and dispatch desk desk have all been set.',
                                color: 'error',
                            });
                            return [2 /*return*/];
                        }
                        // set the site id
                        item.siteId = this.siteId;
                        // open the add dialog
                        this.openDialog(item, 'ADD');
                        return [2 /*return*/];
                }
            });
        });
    };
    UpMarketOpportunities.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var referenceDataResponse, _a, _b, _c, response, defaultDispatchDesk_1, autoGeneratedLoads, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 8, 9, 10]);
                        return [4 /*yield*/, this.referenceDataService.getModulesByRequest({ modules: [
                                    'VOYAGE_WINDOWS',
                                    'LOAD_SOURCE_TYPES',
                                ], includeDeleted: false })];
                    case 1:
                        referenceDataResponse = _d.sent();
                        _a = this.options;
                        return [4 /*yield*/, this.materialService.getBySiteMaterialGroup(this.siteId, 'D')];
                    case 2:
                        _a.materials = (_d.sent()).data;
                        this.options.fromTimeWindows = referenceDataResponse.success ? referenceDataResponse.data.filter(function (item) { return item.module === 'VOYAGE_WINDOWS'; }) : [];
                        this.options.toTimeWindows = referenceDataResponse.success ? referenceDataResponse.data.filter(function (item) { return item.module === 'VOYAGE_WINDOWS'; }) : [];
                        this.options.sourceTypes = referenceDataResponse.success ? referenceDataResponse.data.filter(function (item) { return item.module === 'LOAD_SOURCE_TYPES'; }) : [];
                        _b = this.options;
                        return [4 /*yield*/, this.vendorService.getRefBySiteMatGroup(this.siteId, 'D')];
                    case 3:
                        _b.vendors = (_d.sent()).data;
                        _c = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/carrier/getdispatchdesks')];
                    case 4:
                        _c.carriers = _d.sent();
                        // load the opportunities
                        this.loadingOpportunities = true;
                        return [4 /*yield*/, this.opportunityActionsService.getUpMarketLoads(this.siteId, this.date)];
                    case 5:
                        response = _d.sent();
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        if (!(response.data.filter(function (item) { return item.loadId === 'NEW_LOAD'; }).length > 0)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.carrierService.getDefaultDispatchDesk(this.siteId, 'D')];
                    case 6:
                        defaultDispatchDesk_1 = (_d.sent()).data;
                        response.data = response.data.map(function (item) {
                            // set the default dispatch desk on the new load
                            if (item.loadId === 'NEW_LOAD' && !item.dispatchDeskId) {
                                item.dispatchDeskId = defaultDispatchDesk_1.id;
                                item.dispatchDeskName = defaultDispatchDesk_1.name;
                            }
                            return item;
                        });
                        _d.label = 7;
                    case 7:
                        if (isToday(this.date) || isAfter(this.date, new Date())) {
                            autoGeneratedLoads = response.data.filter(function (item) { return item.loadId === 'NEW_LOAD' && item.materialId === null; });
                            if (autoGeneratedLoads.length === response.data.length) {
                                this.showSnackbar({
                                    text: "Up Market Schedule not available for the Site " + this.siteId,
                                    color: 'warning',
                                });
                            }
                        }
                        else {
                            if (response.data.length === 0) {
                                this.showSnackbar({
                                    text: "No Up Market Opportunity was added on this date " + format(this.date, 'MM/DD/YYYY'),
                                    color: 'warning',
                                });
                            }
                        }
                        // add unique id to everything
                        if (response.data && response.data.length > 0 && response.data[0].hasOwnProperty('id') === false) {
                            response.data = response.data.map(function (item, index) { return (__assign({ id: index + 1 }, item)); });
                        }
                        // update the local collection
                        this.opportunities = response.data;
                        return [3 /*break*/, 10];
                    case 8:
                        error_1 = _d.sent();
                        console.error(error_1);
                        this.showSnackbar({
                            text: 'Unable to get up market opportunities',
                            color: 'error',
                        });
                        return [3 /*break*/, 10];
                    case 9:
                        this.loadingOpportunities = false;
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    UpMarketOpportunities.prototype.onMaterialChanged = function (id, materialId) {
        return __awaiter(this, void 0, void 0, function () {
            var opportunities, matchingMaterial_1, _a, error_2;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        opportunities = __spreadArrays(this.opportunities);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        matchingMaterial_1 = this.options.materials.find(function (item) { return item.materialId === materialId; });
                        // set the material id and default load size
                        _a = this;
                        return [4 /*yield*/, Promise.all(opportunities.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            if (!(item.id === id)) return [3 /*break*/, 4];
                                            if (!matchingMaterial_1) return [3 /*break*/, 2];
                                            _a = item;
                                            return [4 /*yield*/, this.siteService.getDefaultLoadSizeBySiteAndMaterial(this.siteId, matchingMaterial_1.materialTypeId)];
                                        case 1:
                                            _a.loadSize = (_c.sent()).data;
                                            _c.label = 2;
                                        case 2:
                                            // set the material id
                                            item.materialId = materialId;
                                            // get the vendor id and update the available vendors
                                            _b = item;
                                            return [4 /*yield*/, this.updateAvailableVendorsAndGetVendorId(item.vendorId, item.sourceType, this.siteId, materialId)];
                                        case 3:
                                            // get the vendor id and update the available vendors
                                            _b.vendorId = _c.sent();
                                            _c.label = 4;
                                        case 4: return [2 /*return*/, item];
                                    }
                                });
                            }); }))];
                    case 2:
                        // set the material id and default load size
                        _a.opportunities = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        console.error(error_2);
                        this.showSnackbar({
                            text: 'Unable to get default load size for site & material',
                            color: 'warning',
                        });
                        this.options.vendors = [];
                        // set the material id
                        this.opportunities = opportunities.map(function (item) {
                            if (item.id === id) {
                                item.materialId = materialId;
                            }
                            return item;
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UpMarketOpportunities.prototype.onSourceTypeChanged = function (id, val) {
        return __awaiter(this, void 0, void 0, function () {
            var opportunities, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        opportunities = __spreadArrays(this.opportunities);
                        _a = this;
                        return [4 /*yield*/, Promise.all(opportunities.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            if (!(item.id === id)) return [3 /*break*/, 2];
                                            // set the source type
                                            item.sourceType = val;
                                            // get the vendor id and update the available vendors
                                            _a = item;
                                            return [4 /*yield*/, this.updateAvailableVendorsAndGetVendorId(item.vendorId, val, this.siteId, item.materialId)];
                                        case 1:
                                            // get the vendor id and update the available vendors
                                            _a.vendorId = _b.sent();
                                            _b.label = 2;
                                        case 2: return [2 /*return*/, item];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.opportunities = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UpMarketOpportunities.prototype.refresh = function (loadId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.loadData();
                this.$emit('refreshActions', { siteId: this.siteId, date: this.date });
                return [2 /*return*/];
            });
        });
    };
    UpMarketOpportunities.prototype.onVisibleChanged = function (val, oldVal) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (val) {
                    this.loadData();
                }
                return [2 /*return*/];
            });
        });
    };
    UpMarketOpportunities.prototype.getUniqueId = function () {
        return uuid_v4();
    };
    UpMarketOpportunities.prototype.updateAvailableVendorsAndGetVendorId = function (vendorId, sourceType, siteId, materialId) {
        return __awaiter(this, void 0, void 0, function () {
            var availableVendors, matchingVendor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vendorService.getRefBySiteIdSourceTypeMaterialId(siteId, sourceType, materialId)];
                    case 1:
                        availableVendors = _a.sent();
                        // update the available vendors
                        this.options.vendors = availableVendors;
                        matchingVendor = availableVendors.filter(function (item) { return item.vendorId === vendorId; });
                        return [2 /*return*/, matchingVendor.length === 0 ? '' : vendorId];
                }
            });
        });
    };
    Object.defineProperty(UpMarketOpportunities.prototype, "contractSourceType", {
        get: function () {
            return 'CONTRACT';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpMarketOpportunities.prototype, "manualSourceType", {
        get: function () {
            return 'MANUAL';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpMarketOpportunities.prototype, "dieselMaterialGroupId", {
        get: function () {
            return 'D';
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    __decorate([
        lazyInject(TYPES.OpportunityActionsService),
        __metadata("design:type", typeof (_a = typeof OpportunityActionsService !== "undefined" && OpportunityActionsService) === "function" ? _a : Object)
    ], UpMarketOpportunities.prototype, "opportunityActionsService", void 0);
    __decorate([
        lazyInject(TYPES.MaterialService),
        __metadata("design:type", typeof (_b = typeof MaterialService !== "undefined" && MaterialService) === "function" ? _b : Object)
    ], UpMarketOpportunities.prototype, "materialService", void 0);
    __decorate([
        lazyInject(TYPES.VendorService),
        __metadata("design:type", typeof (_c = typeof VendorService !== "undefined" && VendorService) === "function" ? _c : Object)
    ], UpMarketOpportunities.prototype, "vendorService", void 0);
    __decorate([
        lazyInject(TYPES.CarrierService),
        __metadata("design:type", typeof (_d = typeof CarrierService !== "undefined" && CarrierService) === "function" ? _d : Object)
    ], UpMarketOpportunities.prototype, "carrierService", void 0);
    __decorate([
        lazyInject(TYPES.SiteService),
        __metadata("design:type", typeof (_e = typeof SiteService !== "undefined" && SiteService) === "function" ? _e : Object)
    ], UpMarketOpportunities.prototype, "siteService", void 0);
    __decorate([
        Prop({ type: Boolean, required: true, default: false }),
        __metadata("design:type", Boolean)
    ], UpMarketOpportunities.prototype, "tableVisible", void 0);
    __decorate([
        Watch('tableVisible', { immediate: true, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Boolean]),
        __metadata("design:returntype", Promise)
    ], UpMarketOpportunities.prototype, "onVisibleChanged", null);
    UpMarketOpportunities = __decorate([
        Component({
            components: {
                'add-load-prompt': AddLoadPrompt,
                'opportunity-table-row': OpportunityTableRow,
                'opportunity-item': OpportunityItem,
            },
            directives: {
                mask: mask,
            },
        })
    ], UpMarketOpportunities);
    return UpMarketOpportunities;
}(Mixins(TableMixin, OpportunityTableMixin, SnackbarMixin)));
export default UpMarketOpportunities;
